module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABIAAAAaCAMAAACNQ/wIAAAAWlBMVEUAAAC9vb29vb29vb29vb29vb29vb29vb29vb29vb29vb29vb29vb29vb29vb29vb29vb29vb29vb29vb29vb29vb29vb29vb29vb29vb29vb29vb29vb29vb3K4wdhAAAAHXRSTlMA+Cbv4720oYlvWVJHLxjx8Obd1c/Lwambf2MfDMMQoZoAAACoSURBVBjTXY/ZEoUgDEOD4oIK7rv8/2/eWwoqnpdmMpm2gaPZBiGGrUEgma1nTnyktTetC2phXwgNYLIRE1CzWpRaWNVY3Szxp3RyhaTRw9GTlnDLc7ZydwApjZGtkXSKzO9EuJRB8Tu71js/qGBY3AgDFLFVUOk45IoXnxDFRBx6ivhizCWDIy94qmBVYLgcV30wHTmdwYuDrAMRGfWNOdP0xIfqvvYDHRYcZ3jutKYAAAAASUVORK5CYII="


//////////////////
// WEBPACK FOOTER
// ./src/act/march_promotion/img/map.png
// module id = 217
// module chunks = 0